import React from 'react';

export default function IconProfile() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99988 8.24C9.58494 8.24 10.8699 6.95506 10.8699 5.37C10.8699 3.78494 9.58494 2.5 7.99988 2.5C6.41483 2.5 5.12988 3.78494 5.12988 5.37C5.12988 6.95506 6.41483 8.24 7.99988 8.24Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2602 13.5002C13.2602 10.5902 10.9002 8.24023 8.00023 8.24023C5.10023 8.24023 2.74023 10.6002 2.74023 13.5002H13.2602Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
